import { Uuid } from "@formant/core/model/Uuid";

import { IIndexedItem } from "./indexedTypes";

type Update = [Uuid, IIndexedItem];
type ReorderResult = Update[];

export function reorderIndices<T extends IIndexedItem>(
    list: (T & { id: Uuid })[],
    compareFn: (a: T, b: T) => number,
    moveId: Uuid,
    placement: "before" | "after",
    dropId: Uuid,
): ReorderResult {
    // Create a sorted copy of the original list using the provided compare function
    const sorted = [...list].sort(compareFn);

    // Find the index of the item to be moved (movedIdx) and the drop target item (dropIdx)
    const movedIdx = sorted.findIndex(it => it.id === moveId);
    const dropIdx = sorted.findIndex(it => it.id === dropId);

    // Check for invalid conditioneither item is not found, or they are the same item
    if (movedIdx === -1 || dropIdx === -1 || movedIdx === dropIdx) {
        return []; // Return an empty result if any condition is invalid
    }

    // Remove the moved item from the sorted list
    const newSorted = [...sorted];
    const [movedItem] = newSorted.splice(movedIdx, 1);

    // Determine the new index for the moved item
    let newDropIdx = dropIdx;

    if (placement === "after") {
        newDropIdx += 1; // If placing after, increment the new drop index by 1
    }

    // Adjust newDropIdx to account for the removal of the moved item
    if (movedIdx < dropIdx) {
        newDropIdx -= 1; // Decrement the new drop index if the moved item was originally before the drop target
    }

    // Insert the moved item at the new drop index
    newSorted.splice(newDropIdx, 0, movedItem);

    // Create the result array with updated indices
    const updatedList: ReorderResult = newSorted.map((item, index) => [
        item.id,
        { ...item, index },
    ]);

    // Return the updated list
    return updatedList;
}
